import React, { useState, useEffect } from "react";
import "../style/header.css";
import logo from "../img/navbar/vama.png";
import { NavLink } from "react-router-dom";
import DropdownProd from "./DropdownProd";
import DropdownSupport from "./DropdownSupport";
import DropdownDefence from "./DropdownDefence"; // ✅ import Defence dropdown
import Post from "./Post";

export default function Header({ sidebar, showSidebar }) {
  const [dropdown, setDropdown] = useState(false);
  const [dropdownDef, setDropdownDef] = useState(false); // ✅ state for Defence
  const [dropdownSpt, setDropdownSpt] = useState(false);
  const [three, setThree] = useState(false);
  const [four, setFour] = useState(false);
  const [showLinkedIn, setShowLinkedIn] = useState(false);

  function resetActiveStates() {
    document.getElementById("service").classList.remove("active");
    document.getElementById("product").classList.remove("active");
    document.getElementById("defence").classList.remove("active"); // ✅ reset Defence
  }

  useEffect(() => {
    if (four) {
      document.getElementById("product").classList.add("active");
      document.getElementById("service").classList.remove("active");
      document.getElementById("defence").classList.remove("active");
    } else if (three) {
      document.getElementById("service").classList.add("active");
      document.getElementById("product").classList.remove("active");
      document.getElementById("defence").classList.remove("active");
    } else {
      resetActiveStates();
    }
  }, [three, four]);

  function handleNavLinkClick() {
    setShowLinkedIn(false);
    resetActiveStates();
  }

  function handlePostClick() {
    setShowLinkedIn(!showLinkedIn);
    resetActiveStates();
  }

  return (
    <>
      <div className="header">
        <div className="icon">
          <NavLink to="/">
            <img src={logo} alt="logo" />
          </NavLink>
        </div>

        <div className="nav-lists">
          {/* About */}
          <div className="nav-list">
            <NavLink
              id="about-us"
              to="/about-us"
              activeClassName="colorBlue"
              onClick={handleNavLinkClick}
            >
              ABOUT US
            </NavLink>
          </div>

          {/* Support & Services */}
          <div
            className={dropdownSpt ? "nav-list colorBlue" : "nav-list"}
            onMouseEnter={() => setDropdownSpt(true)}
            onMouseLeave={() => setDropdownSpt(false)}
          >
            <NavLink
              id="service"
              className={
                three ? "side-listContainer active" : "side-listContainer"
              }
            >
              SUPPORT & SERVICES{" "}
              <span className="material-symbols-outlined arrow-down">
                arrow_drop_down
              </span>
            </NavLink>
            <DropdownSupport
              dropdownSpt={dropdownSpt}
              setThree={setThree}
              setFour={setFour}
            />
          </div>

          {/* Products */}
          <div
            className={dropdown ? "nav-list colorBlue" : "nav-list"}
            onMouseEnter={() => setDropdown(true)}
            onMouseLeave={() => setDropdown(false)}
          >
            <NavLink
              id="product"
              className={
                four ? "side-listContainer active" : "side-listContainer"
              }
            >
              PRODUCTS{" "}
              <span className="material-symbols-outlined arrow-down">
                arrow_drop_down
              </span>
            </NavLink>
            <DropdownProd
              dropdown={dropdown}
              setThree={setThree}
              setFour={setFour}
            />
          </div>

          {/* ✅ Defence Dropdown */}
          <div
            className={dropdownDef ? "nav-list colorBlue" : "nav-list"}
            onMouseEnter={() => setDropdownDef(true)}
            onMouseLeave={() => setDropdownDef(false)}
          >
            <NavLink
              id="defence"
              className="side-listContainer"
            >
              DEFENCE{" "}
              <span className="material-symbols-outlined arrow-down">
                arrow_drop_down
              </span>
            </NavLink>
            <DropdownDefence dropdown={dropdownDef} />
          </div>

          {/* Articles & Events */}
          <div className="nav-list">
            <NavLink
              id="home"
              to="/articles-and-events"
              activeClassName="colorBlue"
              exact
              onClick={handleNavLinkClick}
            >
              ARTICLES & EVENTS
            </NavLink>
          </div>

          {/* Career */}
          <div className="nav-list">
            <NavLink
              id="career"
              to="/career"
              activeClassName="colorBlue"
              onClick={handleNavLinkClick}
            >
              CAREER
            </NavLink>
          </div>

          {/* RPTO */}
          <div className="nav-list">
            <NavLink
              id="rtpo"
              to="/rpto"
              activeClassName="colorBlue"
              onClick={handleNavLinkClick}
            >
              RPTO
            </NavLink>
          </div>

          {/* Post */}
          <div className="nav-list">
            <NavLink
              id="post"
              to="/post"
              onClick={handlePostClick}
              className="side-listContainer"
            >
              POST
            </NavLink>
          </div>

          {/* Contact */}
          <NavLink to="/contact">
            <button className="btn-contactUs">CONTACT US</button>
          </NavLink>
        </div>

        <span
          className="material-symbols-outlined hamburger"
          onClick={() => {
            showSidebar(!sidebar);
          }}
        >
          menu
        </span>
      </div>

      {showLinkedIn && <Post />}
    </>
  );
}
